'use client'

import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'

// Types
import type { SloganModuleProps } from '@/types/components/organisms/modules/content'

// Each step stays on screen this long
const WORD_DURATION = 2000

const AnimatedSloganTitle = (props: SloganModuleProps) => {
	// Props
	const { prefix, steps } = props

	// Words shown so far; keeps counting so every change after the first animates
	const [count, setCount] = useState(0)

	useEffect(() => {
		const timer = setTimeout(() => {
			setCount(prev => prev + 1)
		}, WORD_DURATION)

		return () => clearTimeout(timer)
	}, [count])

	const current = steps[count % steps.length]

	return (
		<Typography
			variant="h3"
			component="h1"
			sx={{
				fontWeight: 700,
				textAlign: { xs: 'center', md: 'left' },
				fontSize: { xs: 34, md: 44 },
				lineHeight: 1.5,
				mx: { xs: 4, md: 2 }
			}}
		>
			{prefix}
			{/* A new key remounts the word, which replays its CSS fade-in; the first word is already visible on the server */}
			<Box
				component="span"
				key={count}
				sx={{
					display: 'inline-block',
					'@keyframes sloganWordIn': { from: { opacity: 0, translate: '0 10px' }, to: { opacity: 1, translate: '0 0' } },
					...(count > 0 && { animation: 'sloganWordIn .55s ease-in-out' }),
					'@media (prefers-reduced-motion: reduce)': { animation: 'none' }
				}}
			>
				{current.word}
				{current.suffix}
			</Box>
		</Typography>
	)
}

export default AnimatedSloganTitle
